import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo } from 'react';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UILink from 'UIComponents/link/UILink';
import { GOAL_TYPE } from '../../constants/goals';
const AD_GOALS_KBDOC = 'https://knowledge.hubspot.com/forecast/create-ad-goals';
export default function AdsSpendTableHead({
  goalTarget
}) {
  const {
    goalType,
    contactLifecycleStage
  } = goalTarget;
  const lifeCyclestageLabel = goalType === GOAL_TYPE.NUMBER_OF_CONTACTS_IN_LIFECYCLE ? 'numContactsTooltip_jsx' : 'costPerContactTooltip_jsx';
  const goalTypeDataHeader = useMemo(() => {
    const label = /*#__PURE__*/_jsx(FormattedMessage, {
      message: `goals-reporting-lib.detailsPanel.adspend.goalType.${goalType}`,
      options: {
        stage: contactLifecycleStage ? I18n.text(`goals-reporting-lib.detailsPanel.adspend.lifecycleStage.${contactLifecycleStage}`) : null
      }
    });

    if (!contactLifecycleStage) return label;
    return /*#__PURE__*/_jsx(UIHelpIcon, {
      title: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: {
            UILink
          },
          message: `goals-reporting-lib.detailsPanel.adspend.${lifeCyclestageLabel}`,
          options: {
            href: AD_GOALS_KBDOC
          }
        })
      }),
      children: label
    });
  }, [contactLifecycleStage, goalType, lifeCyclestageLabel]);
  const costPerDataHeader = useMemo(() => {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: `goals-reporting-lib.detailsPanel.adspend.goalType.costPer.${goalType}`,
      options: {
        stage: contactLifecycleStage && I18n.text(`goals-reporting-lib.detailsPanel.adspend.lifecycleStage.${contactLifecycleStage}`)
      }
    });
  }, [contactLifecycleStage, goalType]);
  const isGoalTypeCostPerContactLifecycle = goalType === GOAL_TYPE.COST_PER_CONTACT_IN_LIFECYCLE;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "goals-reporting-lib.detailsPanel.adspend.adCampaign"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "goals-reporting-lib.detailsPanel.adspend.adSpend"
          })
        }), /*#__PURE__*/_jsx("th", {
          className: isGoalTypeCostPerContactLifecycle ? 'text-right' : undefined,
          children: goalTypeDataHeader
        }), !isGoalTypeCostPerContactLifecycle && /*#__PURE__*/_jsx("th", {
          className: "text-right",
          children: costPerDataHeader
        })]
      })
    })
  });
}